import {
    Descriptions,
    DescriptionsProps,
    Modal,
    ModalProps,
    Skeleton,
} from 'antd';
import React from 'react';
import Style from './index.module.scss';
import {getTenantLoginParams} from '../../../service';
import useRequest from '../../../../../../Utils/Hooks/useRequest';

interface Props extends ModalProps {
    id: string;
}
const Index = ({id, onOk, ...props}: Props) => {
    const [defaultData, {loading: getLoading}] = useRequest(
        () => getTenantLoginParams(id),
        {},
        [id],
    );

    const items: DescriptionsProps['items'] = [
        {
            key: '2',
            label: '链接地址',
            children: defaultData?.subjectDomainName ? (
                <a href={`//${defaultData?.subjectDomainName}`} target="_blank">
                    {defaultData?.subjectDomainName}
                </a>
            ) : (
                '无'
            ),
        },
        {
            key: '3',
            label: '账号',
            children: defaultData?.loginName,
        },
        {
            key: '4',
            label: '密码',
            children: defaultData?.pwd,
        },
    ];

    return (
        <Modal {...props} title="登录信息" footer={null}>
            <div className={Style.root}>
                <Skeleton active loading={getLoading}>
                    <Descriptions items={items} column={1} />
                </Skeleton>
            </div>
        </Modal>
    );
};

export default Index;
